import React from 'react';
import { heritageColors } from '../../../../heritageTheme.ts';

const TYPE_CONFIGS = {
  medic: { label: 'חובש', icon: 'medical_services', color: '#2d5a3d', bg: '#e8f5e9' },
  paramedic: { label: 'פרמדיק', icon: 'cardiology', color: '#1e3a5f', bg: '#e3f2fd' },
  maar: { label: 'מע"ר', icon: 'healing', color: '#b8860b', bg: '#fff8e1' },
};

/**
 * Grouped – תבנית אנכית עם חלוקה לקבוצות לפי סוג כונן
 * כל קבוצה עם כותרת צבעונית ורשימה מסודרת מתחתיה
 */
const Grouped = ({
  initialData = { volunteers: { medic: [], paramedic: [], maar: [] } },
  title = 'חירום והצלה',
  showTitle = true,
}) => {
  const volunteers = initialData.volunteers || { medic: [], paramedic: [], maar: [] };

  const groups = Object.entries(TYPE_CONFIGS)
    .map(([type, config]) => ({
      type,
      config,
      members: volunteers[type] || [],
    }))
    .filter(g => g.members.length > 0);

  const hasAny = groups.length > 0;

  return (
    <div style={{
      padding: '1em',
      direction: 'rtl',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      fontSize: 'inherit',
    }}>
      {showTitle && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5em',
          borderBottom: `0.03125em solid ${heritageColors.emergency}`,
          paddingBottom: '0.625em',
          marginBottom: '0.75em',
        }}>
          <div style={{
            backgroundColor: heritageColors.emergencyLight,
            borderRadius: '50%',
            padding: '0.3125em',
            display: 'flex',
            border: `0.03125em solid ${heritageColors.emergency}30`,
          }}>
            <span className="material-symbols-outlined" style={{
              color: heritageColors.emergency,
              fontSize: '1.125em',
            }}>ambulance</span>
          </div>
          <h3 style={{
            margin: 0,
            fontWeight: 'bold',
            color: heritageColors.emergency,
            fontSize: '0.875em',
          }}>{title}</h3>
        </div>
      )}

      {!hasAny ? (
        <div style={{ color: heritageColors.emergency, fontSize: '0.875em', textAlign: 'center' }}>
          אין כוננים זמינים
        </div>
      ) : (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.875em',
          flex: 1,
          overflow: 'auto',
        }}>
          {groups.map(({ type, config, members }) => (
            <div key={type}>
              {/* כותרת קבוצה */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.375em',
                marginBottom: '0.375em',
                padding: '0.3125em 0.625em',
                backgroundColor: config.bg,
                borderRadius: '0.25em',
                borderRight: `0.1875em solid ${config.color}`,
              }}>
                <span className="material-symbols-outlined" style={{
                  color: config.color,
                  fontSize: '1em',
                }}>{config.icon}</span>
                <span style={{
                  color: config.color,
                  fontWeight: 'bold',
                  fontSize: '0.8125em',
                }}>{config.label}</span>
                <span style={{
                  color: config.color,
                  fontSize: '0.6875em',
                  opacity: 0.7,
                  marginRight: 'auto',
                }}>({members.length})</span>
              </div>

              {/* חברי הקבוצה */}
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.125em',
                paddingRight: '0.625em',
              }}>
                {members.map((v, idx) => (
                  <div
                    key={v.id || idx}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '0.3125em 0.5em',
                      borderBottom: idx < members.length - 1
                        ? `0.03125em dashed ${heritageColors.borderLight}`
                        : 'none',
                    }}
                  >
                    <span style={{
                      color: heritageColors.navy,
                      fontWeight: 'bold',
                      fontSize: '0.8125em',
                    }}>
                      {v.name}
                    </span>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75em' }}>
                      {v.address && (
                        <span style={{
                          color: heritageColors.slate,
                          fontSize: '0.6875em',
                        }}>
                          {v.address}
                        </span>
                      )}
                      <span style={{
                        color: heritageColors.emergency,
                        fontSize: '0.75em',
                        fontWeight: 'bold',
                        direction: 'ltr',
                      }}>
                        {v.phone}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Grouped;
